import { render, staticRenderFns } from "./ascPatientTypes.vue?vue&type=template&id=d9df1412&"
import script from "./ascPatientTypes.vue?vue&type=script&lang=js&"
export * from "./ascPatientTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports